import { Fragment, useEffect, useState } from "react";
import { getCateListData } from "../../context/apiState.js";
// import { Nav } from "react-bootstrap";
import styles from "../header/HeaderMenu.module.css";


const HaaderCommCate = (props) => {
    
  const getIdFromToken = (adToken) => {
    if (adToken) {
      let idFromToken = adToken.split(".")[1].split("@@")[0];
      // console.log(idFromToken);
      return idFromToken;
    }
  };
  
  return (
    <Fragment>
      {props.allCateData
        ? props.allCateData.footerCategoryAll
            .sort((id, name) => id.catName?.localeCompare(name.catName))
            .map((headerCategoryData, headerCategoryDataIndex) => {
              return (
                <Fragment key={headerCategoryDataIndex}>
                  <a
                    id={styles.navbarId}
                    className={
                      props.headerConfig.catId == headerCategoryData.catId
                        ? styles.headerActive
                        : ""
                    }
                    href={`/category/${headerCategoryData?.catId}/${props.headerConfig.utm_source}/${
                      props.allCateData
                        ? props.allCateData.adSlots
                          ? props.allCateData.adSlots.feedAd
                            ? getIdFromToken(props.allCateData.adSlots.feedAd)
                            : 0
                          : null
                        : null
                    }`}
                    target="_blank"
                  >
                    {headerCategoryData.catName}
                  </a>
                </Fragment>
              );
            })
        : null}
    </Fragment>
  );
};
export default HaaderCommCate;
